import { useState } from "react";
import { Mail } from "lucide-react";
import { subscribeNewsletter } from "@/lib/newsletter.functions";

const C = {
  SURFACE: "var(--card)",
  INK: "var(--primary)",
  INK_SOFT: "var(--ink-secondary)",
  INK_FAINT: "var(--ink-tertiary)",
  BRASS: "var(--editorial-accent, var(--accent))",
  RULE: "var(--rule)",
};

export function NewsletterSignup({ source = "website" }: { source?: string }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">("idle");

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (state === "busy") return;
    setState("busy");
    try {
      await subscribeNewsletter({ data: { email, source } });
      setState("done");
    } catch {
      setState("error");
    }
  }

  return (
    <div
      className="rounded-2xl border px-6 py-8 sm:px-10"
      style={{ background: C.SURFACE, borderColor: C.RULE }}
    >
      <div className="flex items-start gap-3">
        <Mail className="mt-0.5 h-5 w-5 shrink-0" style={{ color: C.BRASS }} />
        <div className="min-w-0 flex-1">
          <h2 className="text-lg font-semibold" style={{ color: C.INK }}>
            Get study-writing tips by email
          </h2>
          <p className="mt-1 text-sm" style={{ color: C.INK_SOFT }}>
            Occasional notes on essay feedback, referencing and using AI safely
            at university. No spam — unsubscribe any time.
          </p>
          {state === "done" ? (
            <p className="mt-4 text-sm font-medium" style={{ color: C.BRASS }}>
              You&apos;re on the list — thank you!
            </p>
          ) : (
            <form
              onSubmit={onSubmit}
              className="mt-4 flex flex-col gap-2 sm:flex-row"
            >
              <label htmlFor="newsletter-email" className="sr-only">
                Email address
              </label>
              <input
                id="newsletter-email"
                type="email"
                required
                maxLength={255}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@university.ac.uk"
                className="w-full flex-1 rounded-full border bg-transparent px-4 py-2.5 text-sm outline-none"
                style={{ borderColor: C.RULE, color: C.INK }}
              />
              <button
                type="submit"
                disabled={state === "busy"}
                className="rounded-full px-5 py-2.5 text-sm font-medium disabled:opacity-60"
                style={{ background: C.INK, color: C.SURFACE }}
              >
                {state === "busy" ? "Joining…" : "Join the list"}
              </button>
            </form>
          )}
          {state === "error" && (
            <p className="mt-2 text-sm" style={{ color: C.INK_SOFT }}>
              Something went wrong — please try again.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
